import React, { useState, useEffect } from 'react'
import './index.less'
import { useAppSelector } from '@/hooks'
import Position from '@/components/Compare/Position'

export default function PositionCompare(props) {
  const { class1 } = props
  const globalTags = useAppSelector((state) => state.compareInfo.globalTags)

  const globalTagTree = useAppSelector((state) => state.compareInfo.globalTagTree)

  const [currentTags, setCurrentTags] = useState<string[]>([])
  const [currentImgSrc, setCurrentImgSrc] = useState<string>('')
  //设置当前画作的构图tags（TODO:同步后端数据）
  // useEffect(() => {
  //   const goutuTags = globalTags.filter((item) => item.typeName === "构图")
  //   if (goutuTags.length > 0) {
  //     setCurrentTags(goutuTags[0].tags)
  //   }
  // }, [])
  useEffect(() => {
    setCurrentTags(globalTags.构图)
    if (globalTags.构图.length > 0) {
      const goutuInfo = globalTagTree.构图.filter((item) => item.title === globalTags.构图[0])
      if (goutuInfo.length > 0) {
        setCurrentImgSrc(goutuInfo[0].imgSrc ?? '')
      }
    }
  }, [globalTagTree.构图, globalTags.构图])
  return (
    <div className='compare-position'>
      <Position currentTags={currentTags} currentImgSrc={currentImgSrc} class1={class1} />
    </div>
  )
}
